import React, { useState, useCallback } from 'react';
import { useStore } from 'effector-react';
import { $isMobile } from '../../effector/main';

export const useKinohod = () => {
    const [showWidget, setShowWidget] = useState(false);
    const [seanceId, setSeanceId] = useState('');
    const isMobile = useStore($isMobile);

    const handleOpen = useCallback((seanceId) => {
        setShowWidget(true);

        setSeanceId(seanceId);
        const kinohodParam = `widget:seance,id:${seanceId}`;
        const encodedParam = encodeURIComponent(kinohodParam);

        const { pathname, hash } = window.location;
        const newUrl = `${pathname}?kinohod=${encodedParam}${hash}`;

        window.history.replaceState(null, "", newUrl);
    }, []);

    const handleClose = useCallback(() => {
        setShowWidget(false);

        const { pathname, hash } = window.location;
        window.history.replaceState(null, "", pathname + hash);

    }, []);

    return {
        showWidget,
        seanceId,
        isMobile,
        handleOpen,
        handleClose,
    }
}